<div class="main-menu" [class.is-mobile]="isMobile">
  <ul>
    <ng-container *ngIf="!isOnboarding && !isBlocked">
      <li 
    [routerLink]="getDashboardLink()"
      [routerLinkActive]="['is-active']" 
      [routerLinkActiveOptions]="{ exact: true }">
  <i class="app-ico app-ico__menu-dashboard"></i>

  <span class="is-title">{{ 'MainMenu.Dashboard' | translate }}</span>

</li>
     <li *ngIf="(role$ | async) === USER_ROLES.hm" 
    [routerLink]="['/' + basePath + '/vacancies/list']" 
    [routerLinkActive]="['is-active']">
  <i class="app-ico app-ico__menu-vacancies"></i>

  <span class="is-title">{{ 'MainMenu.Vacancies' | translate }}</span>

</li>
      <li *ngIf="(role$ | async) === USER_ROLES.talent"
    [routerLink]="['/' + basePath + '/vacancies']" 
    [routerLinkActive]="['is-active']">
  <i class="app-ico app-ico__menu-vacancies"></i>

  <span class="is-title">{{ 'MainMenu.Vacancies' | translate }}</span>

</li>

      <!-- <li [routerLink]="['/' + basePath + '/messages']" 
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__menu-chat"></i>

        <span class="is-title">{{ 'MainMenu.Messages' | translate }}</span>

        <span class="is-count" *ngIf="messageCount$ | async">
          <span class="is-title">{{ messageCount$ | async }}</span>
        </span>
      </li> -->
     
      <!-- <li *ngIf="(role$ | async) === USER_ROLES.hm">
        <i class="app-ico app-ico__menu-finances"></i>
        <span class="is-title">Finances</span>
      </li> -->
      <!-- <li [routerLink]="['/' + basePath + '/notifications']"
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__menu-notification"></i>
        <span class="is-title">Notifications</span>
        <span class="is-count" *ngIf="notifyCount$ | async">
          <span class="is-title">{{ notifyCount$ | async }}</span>
        </span>
      </li> -->
      <li *ngIf="(role$ | async) === USER_ROLES.hm"
        [routerLink]="['/' + basePath + '/applies']" 
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__dimond"></i>

        <span class="is-title">{{ 'MainMenu.Applications' | translate }}</span>

        <span class="is-count" *ngIf="appliesCount$ | async">
          <span class="is-title">{{ appliesCount$ | async }}</span>
        </span>
      </li>
      <!-- <li *ngIf="(role$ | async) === USER_ROLES.hm"
        [routerLink]="['/dashboard/analytics']" 
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__menu-dashboard"></i>

        <span class="is-title">{{ 'MainMenu.Analytics' | translate }}</span>
      </li> -->
      <li *ngIf="(role$ | async) === USER_ROLES.talent && skillsValidation"
        [routerLink]="['/' + basePath + '/skills-validation']" 
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__skills-validation"></i>

        <span class="is-title">{{ 'MainMenu.SkillsValidation' | translate }}</span>
      </li>
      <li *ngIf="(role$ | async) === USER_ROLES.admin"
        [routerLink]="['/dashboard/hard-skills']" 
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__hard-skills"></i>

        <span class="is-title">{{ 'MainMenu.HardSkills' | translate }}</span>
      </li>
      <li *ngIf="(role$ | async) === USER_ROLES.admin"
        [routerLink]="['/dashboard/users']" 
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__menu-profile"></i>

        <span class="is-title">{{ 'MainMenu.Users' | translate }}</span>
      </li>
       <li *ngIf="(role$ | async) === USER_ROLES.admin"
        [routerLink]="['/dashboard/configuration']" 
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__menu-settings"></i>
        <span class="is-title">{{ 'MainMenu.Configuration' | translate }}</span>
      </li>
      <li *ngIf="(role$ | async) === USER_ROLES.admin"
        [routerLink]="['/dashboard/upload-cvs']"
        [routerLinkActive]="['is-active']">
        <i class="app-ico app-ico__menu-upload-cvs"></i>
        <span class="is-title">{{ 'MainMenu.UploadCVs' | translate }}</span>
      </li>
      <li *ngIf="(role$ | async) === USER_ROLES.admin"
        [routerLink]="['/dashboard/job-boards/naukri']"
        [routerLinkActive]="['is-active']"
        [routerLinkActiveOptions]="{ exact: true }">
        <i class="app-ico app-ico__menu-vacancies"></i>
        <span class="is-title">Job Boards</span>
      </li>
    </ng-container>
    <ng-container *ngIf="isMobile">
      <ng-container *ngIf="!isBlocked">
        <li class="is-profile" 
          [routerLink]="[(role$ | async) === USER_ROLES.hm ? '/hm/profile' : '/talent/profile']"
          [routerLinkActive]="['is-active']"
          *ngIf="!isOnboarding">
          <i class="app-ico app-ico__menu-profile"></i>

          <span class="is-title">{{ 'MainMenu.Profile' | translate }}</span>
        </li>
        <li 
          [routerLink]="['/dashboard/settings']"
          [routerLinkActive]="['is-active']"
          *ngIf="!isOnboarding">
          <i class="app-ico app-ico__menu-settings"></i>

          <span class="is-title">{{ 'MainMenu.Settings' | translate }}</span>
        </li>
        <li class="is-separator" *ngIf="!isOnboarding"></li>
      </ng-container>
      <li (click)="logout()">
        <i class="app-ico app-ico__menu-sign-out"></i>

        <span class="is-title">{{ 'MainMenu.SignOut' | translate }}</span>
      </li>
    </ng-container>
  </ul>
</div>
